import { render, staticRenderFns } from "./MapLegend.vue?vue&type=template&id=00f5a667&scoped=true"
import script from "./MapLegend.vue?vue&type=script&lang=js"
export * from "./MapLegend.vue?vue&type=script&lang=js"
import style0 from "./MapLegend.vue?vue&type=style&index=0&id=00f5a667&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f5a667",
  null
  
)

export default component.exports